import { Col, Row } from "antd";
import styles from "./VideoCall.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { BsFillMicFill, BsFillMicMuteFill } from "react-icons/bs";
import { MdCallEnd } from "react-icons/md";
import { TbRefreshDot } from "react-icons/tb";

import { useEffect, useState } from "react";

import {
  LocalUser,
  RemoteUser,
  useClientEvent,
  useJoin,
  useLocalCameraTrack,
  useLocalMicrophoneTrack,
  usePublish,
  useRTCClient,
  useRemoteAudioTracks,
  useRemoteUsers,
} from "agora-rtc-react";
import { VideoCallMiddleware } from "../../../../Store/Middlewares/VideoCallMiddleware";
import { useDispatch, useSelector } from "react-redux";
import { hideRinging } from "../../../../Store/Actions/GeneralActions";

const VideoCall = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(state => state.AuthReducer.user);
  const ringingOptions = useSelector((state) => state.GeneralReducer.ringingOptions);
  const location = useLocation();
  const chatData = location?.state?.data
  const config = {
    appId: '139bdabf155141fb810a1c0de545dd58',
    token: chatData?.token,
    channelName: chatData?.channel_name,
  };

  const [activeConnection, setActiveConnection] = useState(true);

  // track the mic/video state - Turn on Mic and Camera On
  const [micOn, setMic] = useState(true);
  const [cameraOn, setCamera] = useState(true);

  // get local video and mic tracks
  const { localMicrophoneTrack } = useLocalMicrophoneTrack(micOn);
  const { localCameraTrack } = useLocalCameraTrack(cameraOn);

  useJoin(
    {
      appid: config.appId,
      channel: config.channelName,
      token: config.token,
    },
    activeConnection,
  );

  usePublish([localMicrophoneTrack, localCameraTrack]);

  // useClientEvent("user-left", (user) => {
  //   console.log("The user" , user.uid , " has left the channel");
  // });

  const remoteUsers = useRemoteUsers();
  const { audioTracks } = useRemoteAudioTracks(remoteUsers);

  audioTracks.forEach((track) => track.play());

  const leaveChannel = async () => {

    setActiveConnection(false)
    dispatch(hideRinging());
    navigate(-1)
  };

  const endCall = async () => {
    dispatch(VideoCallMiddleware.declineCall({ channel: config.channelName }))
      .then((data) => {
        leaveChannel()
      })
  };
  // useEffect(() => {
  //   if (remoteUsers.length == 0) {
  //     endCall()
  //   }
  // }, [remoteUsers])
  // const agoraEngine = useRTCClient();

  // console.log('agoraEngine', agoraEngine)
  return (
    <div className={styles.container}>
      <LocalUser
        audioTrack={localMicrophoneTrack}
        videoTrack={localCameraTrack}
        cameraOn={cameraOn}
        micOn={micOn}
        playAudio={false}
        playVideo={cameraOn}
        className={styles.bgImg}
      />
      <div className={styles.pinkBg}></div>

      <div >
        <Row className={styles.personRow}>
          {remoteUsers.map((user) => (
            <div className={styles.personColGroup}>
              <RemoteUser user={user} />
            </div>
          ))}

        </Row>
        <Row className={styles.iconRow}>
          <Col>
            <TbRefreshDot className={styles.icon} onClick={() => setCamera(a => !a)} />
          </Col>
          <Col>
            <div className={styles.redIcon} onClick={endCall}>
              <MdCallEnd className={styles.icon} />
            </div>
          </Col>
          <Col>
            {micOn ? (
              <BsFillMicFill
                className={styles.icon}
                onClick={() => setMic(a => !a)}
              />
            ) : (
              <BsFillMicMuteFill
                className={styles.icon}
                onClick={() => setMic(a => !a)}
              />
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default VideoCall;
